// Generated by tutorials/record.cjs from tutorials/articles/h51-asking-to-swap-two-meals.cjs.
// Do not edit: change the script and run `node tutorials/record.cjs h51 --text-only` (wording) or
// `node tutorials/record.cjs h51` (pictures and clips).
import type { HelpArticle } from '../types';

const article: HelpArticle = {
  slug: 'asking-to-swap-two-meals',
  catalogId: 'h51',
  title: 'Asking to swap two meals',
  summary: 'Ask PSI to trade two meals on your menu cycle, such as Wednesday lunch with Thursday lunch. Check both menus, say whether it is for good or one date, and send it.',
  audience: 'Dietary managers who want two meals traded on the menu',
  area: 'menus',
  learn: [
    'Pick the two meals to trade',
    'Check both menus before you send',
    'Say whether the swap is for good or for one date',
    'Follow the request in Your requests',
  ],
  keywords: [
    'swap',
    'swap meals',
    'trade meals',
    'switch days',
    'move meal',
    'menu change',
    'change request',
    'request a menu change',
    'ask psi',
    'your requests',
    'delete request',
    'cancel request',
    'withdraw request',
  ],
  steps: [
    {
      id: 'swap',
      part: 'Pick the two meals',
      heading: 'Select Swap two meals',
      text: 'Under Menus, select Menu Changes, then Ask PSI. Check the menu cycle at the top, and select Swap two meals.\n\nThe page shows two meals side by side: Swap this on the left and With this on the right. Swap this starts on today and lunch, and With this on the next day.',
      media: {
        image: {
          src: '/help/asking-to-swap-two-meals/swap.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/asking-to-swap-two-meals/swap.mp4',
          width: 1280,
          height: 842,
          durationSec: 3,
        },
        alt: 'Swap two meals selected: Swap this and With this, each with its day and meal buttons and its menu.',
      },
    },
    {
      id: 'pick',
      part: 'Pick the two meals',
      heading: 'Pick the days and meals',
      text: 'On each side, select the day and the meal. Here With this moves to two days later.\n\nBoth menus show underneath, so you can check what you are trading before you send. When both sides are the same meal, a red note says so and the request cannot be sent.',
      media: {
        image: {
          src: '/help/asking-to-swap-two-meals/pick.webp',
          width: 1280,
          height: 916,
        },
        clip: {
          src: '/help/asking-to-swap-two-meals/pick.mp4',
          width: 1280,
          height: 916,
          durationSec: 4.4,
        },
        alt: 'Swap this on Day 4 Lunch and With this on Day 6 Lunch, each with its menu, and the arrow between them.',
      },
    },
    {
      id: 'send',
      part: 'Send it',
      heading: 'Say when, and send',
      text: 'Under When, keep Every time this cycle comes around to trade the meals for good, or pick Just one date and choose the date.\n\nAdd Notes, such as why you want the swap. Check Phone and Email, then select Send request.',
      media: {
        image: {
          src: '/help/asking-to-swap-two-meals/send.webp',
          width: 1280,
          height: 414,
        },
        clip: {
          src: '/help/asking-to-swap-two-meals/send.mp4',
          width: 1280,
          height: 414,
          durationSec: 6,
        },
        alt: 'When set to Every time this cycle comes around, Notes saying the delivery now comes on Thursdays, Phone and Email, and Send request.',
      },
    },
    {
      id: 'requests',
      part: 'Send it',
      heading: 'Follow it in Your requests',
      text: 'The top of the page says Request sent to PSI, with the request number.\n\nYour requests lists it as Swap these two meals, with both days. Its status changes as PSI works on it, and PSI\'s reply shows beside it.\n\nWhile it is still New, you can take it back: select Delete on its row, then Delete again to confirm. PSI won\'t work on it. Once PSI has started it, there is no Delete; call PSI instead.',
      media: {
        image: {
          src: '/help/asking-to-swap-two-meals/requests.webp',
          width: 1280,
          height: 380,
        },
        clip: {
          src: '/help/asking-to-swap-two-meals/requests.mp4',
          width: 1280,
          height: 380,
          durationSec: 3.3,
        },
        alt: 'Your requests: the new swap at the top with status New, then the earlier requests with their status and PSI\'s reply.',
      },
    },
  ],
  tips: [
    'The two meals do not have to be the same meal: you can trade a lunch with a dinner.',
    'Use Notes to say why, such as a delivery day, so PSI can suggest something else if the swap does not work.',
  ],
  notes: [
    'Sending a request does not change your menu. PSI makes the swap in your menu cycle and replies in Your requests.',
    'With menu cycle override rights you can swap meals yourself, straight away, on Menu Swap. See Menu Swap and Change Requests.',
  ],
  related: ['asking-for-a-menu-change', 'menu-swap-and-requests', 'reading-a-menu-cycle'],
  recorded: '2026-11-02',
};

export default article;
